var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('@rtm-ui/layout'), require('styled-components'), require('@rtm-ui/icon'), require('@rtm-ui/typography')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', '@rtm-ui/layout', 'styled-components', '@rtm-ui/icon', '@rtm-ui/typography'], factory) : (global = global || self, factory(global.list = {}, global.React, global.PropTypes, global.RtmUiLayout, global.styled, global.RtmUiIcon, global.RtmUiTypography));
})(this, function (exports, React, PropTypes, layout, styled, icon, typography) {
  'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var Wrapper = styled(layout.Box)(_templateObject());
  var ContentWrapper = styled(layout.Box)(_templateObject2());

  var ListItem = function ListItem(_ref) {
    var icon$1 = _ref.icon,
        fill = _ref.fill,
        size = _ref.size,
        strokePrimary = _ref.strokePrimary,
        strokeSecondary = _ref.strokeSecondary,
        children = _ref.children;
    return (
      /*#__PURE__*/
      React.createElement(layout.Box, {
        style: {
          height: '100%'
        },
        my: [2]
      },
      /*#__PURE__*/
      React.createElement(Wrapper, null, icon$1 &&
      /*#__PURE__*/
      React.createElement(layout.Box, {
        pr: [1, 2, 3]
      },
      /*#__PURE__*/
      React.createElement(icon.Icon, {
        glyph: icon$1,
        size: size,
        fill: fill,
        strokePrimary: strokePrimary,
        strokeSecondary: strokeSecondary
      })),
      /*#__PURE__*/
      React.createElement(ContentWrapper, null, children)))
    );
  };

  ListItem.propTypes = {
    icon: PropTypes.string,
    children: PropTypes.node.isRequired,
    fill: PropTypes.string,
    strokePrimary: PropTypes.string,
    strokeSecondary: PropTypes.string,
    size: PropTypes.number
  };

  var List = function List(_ref2) {
    var header = _ref2.header,
        subHeader = _ref2.subHeader,
        children = _ref2.children;
    return (
      /*#__PURE__*/
      React.createElement(layout.Box, {
        my: [3]
      }, children && children.map(function (item, index) {
        return (
          /*#__PURE__*/
          React.createElement(ListItem, _extends({
            key: index
          }, item, {
            header:
            /*#__PURE__*/
            React.createElement(typography.Markdown, {
              raw: header
            }),
            subHeader:
            /*#__PURE__*/
            React.createElement(typography.Markdown, {
              raw: subHeader
            })
          }),
          /*#__PURE__*/
          React.createElement("div", null, item.body))
        );
      }))
    );
  };

  List.propTypes = {
    header: PropTypes.string,
    subHeader: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      body: PropTypes.any,
      fill: PropTypes.string
    }))
  };
  exports.List = List;
  exports.ListItem = ListItem;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});